import React from 'react';
import { socket } from '../../util/socket';
import { api_bd_nr } from '../../services/Api';

const HermesStats = () => {
    const [hermesData, setHermesData] = React.useState(null);

    const handleHermesStats = (data) => {
        if (data?.topic && data.topic === 'updateHermesStats') {
            console.log('Hermes Stats update from socket');
            loadHermesStats()
        }
        
        
    };


    const loadHermesStats = () => {
        api_bd_nr.get('/analystreports/hermesstats').then((response) => {
            console.log('Hermes Stats (API):', response.data);
            setHermesData(response.data.length > 0 ? response.data : []);
        }).catch((error) => {
            console.error('Error fetching Hermes Stats:', error);
        });
    }

    

    React.useEffect(() => {
        socket.on('sgi-int', handleHermesStats)

        loadHermesStats()

        return () => {
            socket.off('sgi-int', handleHermesStats)
        }
    }, [])

    return (
        <div className="hermes-stats">
            <h2 className='text-lg font-semibold text-center mb-2'>Hermes Stats - chats abertos</h2>

            {/* CHATS AQUI */}
            {hermesData && hermesData.length > 0 ? (
                <div>
                    <div className="">
                        <p>Total de Chats: {String(hermesData.length).padStart(2, '0')}</p>
                        <p>Chats ativos: {hermesData.length > 0 ? String(hermesData.filter(el => el.state !== "waiting").length).padStart(2, '0') : '0'}</p>
                        <p>Chats em espera: {hermesData.length > 0 ? String(hermesData.filter(el => el.state === "waiting").length).padStart(2, '0') : '0'}</p>
                    </div>

                    <div className="mt-4">
                        <p>Chats</p>
                        {hermesData.map((chat, index) => (
                            <details key={`hermesstats_${index}`} className='mb-4 border rounded' >
                                <summary className='cursor-pointer select-none text-base font-bold px-3 py-2 bg-gray-50'>
                                    {chat.client} ({chat?.state === "initiated" ? "Em tratativa" : "Na fila"})<span className='font-normal text-gray-500'></span>
                                </summary>
                                {/* <p>Cliente: {chat.client}</p> */}
                                <p className='px-2'>Chat ID: {chat?.hermesChatId || 0}</p>
                                {/* <p>State: {chat?.state === "initiated" ? "Em tratativa" : "Na fila"}</p> */}
                                <p className='px-2'>Time: {(chat?.team ? chat?.team?.toUpperCase() : 'Não atribuído')}</p>
                                <p className='px-2'>Aberto em: {new Date(chat?.created) ? `${new Date(chat?.created).toLocaleDateString()} às ${new Date(chat?.created).toLocaleTimeString()}` : 'Não informado'}</p>
                                <p className='px-2'>Responsável: {chat?.assignee || 'Não atribuído'}</p>
                            </details>
                        ))}
                    </div>
                </div>
            ) : (
                <p className='text-center text-gray-500'>Carregando dados do Hermes...</p>
            )}
        </div>
    );
};

export default HermesStats;
